// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DatapointsRequestBaseFromJSON, DatapointsRequestBaseToJSON, DatapointsRequestOptionsFromJSON, DatapointsRequestOptionsToJSON, DatapointsRequestSpecificsFromJSON, DatapointsRequestSpecificsToJSON, } from './';
export function DatapointsRequestFromJSON(json) {
    return {
        ...DatapointsRequestBaseFromJSON(json),
        ...DatapointsRequestOptionsFromJSON(json),
        ...DatapointsRequestSpecificsFromJSON(json),
    };
}
export function DatapointsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        ...DatapointsRequestBaseToJSON(value),
        ...DatapointsRequestOptionsToJSON(value),
        ...DatapointsRequestSpecificsToJSON(value),
    };
}
